<!--
~ Copyright (C) 2023 to Present Applause App Quality, Inc. All rights reserved.
-->

<ngf-responsive-pill-list large
  [showChevron]="true"
  [showClearAll]="true"
  [minPills]="1"
  [positions]="positions"
  (openChanged)="select.optionsOverlay.close()"
  (clearAll)="clearAll.emit($event)">
  @for (value of values; track value) {
    @if (value | displayValue: select.displayWith: select.nullAsValue; as text) {
      <ngf-pill *ngfResponsivePill="let c = collapsed;"
        large
        class="multi-select-pill"
        [ngfTooltip]="text"
        [ngfTooltipDisabled]="text?.length <= (c ? collapsedPillTruncateThreshold : pillTruncateThreshold)"
        [removable]="!select.disabled"
        [ariaLabel]="'Remove ' + text + ' pill'"
        (remove)="handleRemove($event, value)">
        {{ text | ellipsize:(c ? collapsedPillTruncateThreshold : pillTruncateThreshold) }}
      </ngf-pill>
    }
  }
</ngf-responsive-pill-list>
